var map = {
	"./404.png": 2359,
	"./ComingSoon.png": 2625,
	"./Ellipse 192 (1).png": 8991,
	"./Ellipse 192 (2).png": 1824,
	"./Ellipse 192 (3).png": 5864,
	"./Ellipse 192 (4).png": 9150,
	"./Ellipse 192.png": 8791,
	"./Group 40313.png": 3369,
	"./IMG_6920 (1).png": 1947,
	"./Image Hero.png": 5618,
	"./LOGO UPMRC (1)-1 1.png": 8335,
	"./LooperGroup.png": 9562,
	"./Mask group (1).png": 6996,
	"./Mask group (2).png": 6466,
	"./Mask group.png": 3858,
	"./Mask group1.png": 9089,
	"./Mask group121.png": 4317,
	"./Mask group125.png": 6338,
	"./Mask group127.png": 4433,
	"./Mask group2.png": 4226,
	"./Mask group212.png": 778,
	"./Mask group24.png": 7654,
	"./Mask group27.png": 1220,
	"./Mask group28.png": 839,
	"./Mask group29.png": 3847,
	"./Mask group3.png": 975,
	"./Mask group30.png": 1367,
	"./Mask group31.png": 2494,
	"./Mask group32.png": 8880,
	"./Mask group33.png": 1796,
	"./Mask group34.png": 1242,
	"./Mask group35.png": 1145,
	"./Mask group4.png": 9672,
	"./Mask group5.png": 6522,
	"./Mask group6.png": 6358,
	"./Mask group8.png": 2385,
	"./Mygov 1.png": 6912,
	"./Rectangle 40504.png": 1091,
	"./Subtract_Sape.png": 9329,
	"./UPMRCL 1.png": 7086,
	"./about/Agra.png": 1023,
	"./about/Kanpur.png": 3552,
	"./about/Lucknow.png": 2061,
	"./about/about1.png": 5226,
	"./about/about2.png": 7835,
	"./about/about3.png": 3852,
	"./about/about4.png": 1532,
	"./about/about5.png": 8120,
	"./agra.png": 6294,
	"./agra/pattern1.png": 8596,
	"./agra/pattern10.png": 9744,
	"./agra/pattern11.png": 7430,
	"./agra/pattern12.png": 1821,
	"./agra/pattern13.png": 4417,
	"./agra/pattern14.png": 1333,
	"./agra/pattern15.png": 1994,
	"./agra/pattern16.png": 3274,
	"./agra/pattern17.png": 1670,
	"./agra/pattern3.png": 5567,
	"./agra/pattern4.png": 6346,
	"./agra/pattern6.png": 637,
	"./agra/pattern7.png": 5004,
	"./agra/pattern8.png": 4310,
	"./banner/1.png": 7076,
	"./banner/2.png": 8481,
	"./banner/3.png": 6713,
	"./banner/4.png": 8614,
	"./banner/5.png": 9986,
	"./certificate-logo.png": 1322,
	"./chairman.png": 6986,
	"./content-bg.png": 3584,
	"./events/events-pattern.png": 690,
	"./events/image-1.png": 8773,
	"./events/image-2.png": 9638,
	"./events/image-3.png": 8699,
	"./events/image-4.png": 9758,
	"./fare-bg.png": 5826,
	"./feedback.png": 829,
	"./home-banner-1.png": 2979,
	"./home-banner-2.png": 4338,
	"./home-banner-3.png": 6905,
	"./home-banner.png": 2150,
	"./home.png": 2402,
	"./kanpur-go-smart-card.png": 7034,
	"./kanpur.png": 9099,
	"./kanpur/pattern1.png": 7571,
	"./kanpur/pattern10.png": 5993,
	"./kanpur/pattern11.png": 6949,
	"./kanpur/pattern12.png": 2729,
	"./kanpur/pattern13.png": 657,
	"./kanpur/pattern14.png": 533,
	"./kanpur/pattern15.png": 1052,
	"./kanpur/pattern16.png": 8191,
	"./kanpur/pattern17.png": 2031,
	"./kanpur/pattern3.png": 4595,
	"./kanpur/pattern4.png": 7804,
	"./kanpur/pattern6.png": 9517,
	"./kanpur/pattern7.png": 6618,
	"./kanpur/pattern8.png": 998,
	"./kisspng-digital-india-government-of-india-indian-institute-qutub-minar-5b55b542bf86d6 1.png": 2609,
	"./lang.png": 6246,
	"./letter_send.png": 5950,
	"./login-bg.png": 933,
	"./logo-white.png": 6286,
	"./logo.png": 4427,
	"./logo_en 1.png": 6951,
	"./lost-found.png": 6456,
	"./lost-found/lost-found1.png": 1621,
	"./lost-found/lost-found2.png": 8947,
	"./lost-found/lost-found3.png": 9265,
	"./lost-found/lost-found4.png": 3040,
	"./lucknow.png": 2202,
	"./lucknow/pattern1.png": 9598,
	"./lucknow/pattern10.png": 7661,
	"./lucknow/pattern11.png": 6429,
	"./lucknow/pattern12.png": 2946,
	"./lucknow/pattern13.png": 5240,
	"./lucknow/pattern14.png": 5598,
	"./lucknow/pattern15.png": 9044,
	"./lucknow/pattern16.png": 9645,
	"./lucknow/pattern17.png": 5962,
	"./lucknow/pattern3.png": 8079,
	"./lucknow/pattern4.png": 6103,
	"./lucknow/pattern6.png": 743,
	"./lucknow/pattern7.png": 1421,
	"./lucknow/pattern8.png": 7554,
	"./no-item.png": 5213,
	"./no-route.png": 3188,
	"./opportunities/buseness1.png": 400,
	"./opportunities/business.png": 478,
	"./opportunities/celebrate.png": 8348,
	"./opportunities/celebrate1.png": 3108,
	"./opportunities/dos-and-donts.png": 7575,
	"./opportunities/dos-and-donts1.png": 668,
	"./opportunities/growth.png": 4030,
	"./opportunities/growth1.png": 7673,
	"./opportunities/save-with1.png": 2234,
	"./pattern1.png": 2706,
	"./pattern2.png": 1954,
	"./pattern3.png": 5531,
	"./place.png": 6956,
	"./search.png": 7561,
	"./sitemap.png": 4258,
	"./station.png": 7822,
	"./train-transit.png": 5847,
	"./train.png": 3500,
	"./web.png": 7045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;